import { field, date, writer, relation, text } from "@nozbe/watermelondb/decorators";
import { ATTENDANCE_SCHEMA, JOURNAL_SCHEMA } from "../schema";
import { Model } from "@nozbe/watermelondb";
import { database } from "../index";

export default class Attendance extends Model {
  static table = ATTENDANCE_SCHEMA;

  static associations = {
    business: { type: "belongs_to", key: "business_id" },
    journal: { type: "belongs_to", key: "journal_id" },
    staff: { type: "belongs_to", key: "staff_id" },
  };

  @field("extra_payment") extra_payment;
  @field("total_minutes") total_minutes;
  @text("extra_mode") extra_mode;
  @field("payment") payment;
  @field("status") status;
  @field("wage") wage;

  @date("last_updated_at") last_updated_at;
  @date("attendance_at") attendance_at;
  @date("check_out_at") check_out_at;
  @date("check_in_at") check_in_at;

  @relation("business", "business_id") business;
  @relation("staff", "staff_id") staff;
  @relation("journal", "journal_id") journal;

  @writer async updateAttendance(details) {
    await this.update((attendance) => {
      attendance.last_updated_at = details.last_updated_at;
      attendance.status = details.status;
      attendance.payment = details.payment;
    });
  }

  @writer async updateJournalId(data) {
    const journal_model = database.collections.get(JOURNAL_SCHEMA);
    let getJournal = await journal_model.find(data.journal_id);

    await this.update((attendance) => {
      attendance.journal.set(getJournal);
      attendance.last_updated_at = data.last_updated_at;
    });
  }

@writer async updateAttendanceAndJournal(data, journal_data) {
  await this.update((attendance) => {
    attendance.last_updated_at = data.last_updated_at;
    attendance.status = data.status;
    attendance.payment = data.payment;
    attendance.extra_mode = data.extra_mode;
    attendance.extra_payment = data.extra_payment;
    attendance.wage = data.wage;
    attendance.total_minutes = data.total_minutes;
  });

  const journal_model = database.collections.get(JOURNAL_SCHEMA);

  const getJournal = await journal_model.find(journal_data.id);

  await getJournal.updateSalaryJournal(journal_data);
}

  @writer async updateExtraAttendance(details) {
    await this.update((attendance) => {
      attendance.last_updated_at = details.last_updated_at;
      attendance.status = details.status;
      attendance.payment = details.payment;
      attendance.extra_mode = details.extra_mode;
      attendance.extra_payment = details.extra_payment;
      attendance.wage = details.wage;
      attendance.total_minutes = details.total_minutes;
    });
  }

  @writer async markAsDeleted() {
    await super.markAsDeleted();
  }
}
